import { render, staticRenderFns } from "./EditorFullscreen.vue?vue&type=template&id=58a93e30&scoped=true&"
import script from "./EditorFullscreen.vue?vue&type=script&lang=js&"
export * from "./EditorFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./EditorFullscreen.vue?vue&type=style&index=0&id=58a93e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a93e30",
  null
  
)

export default component.exports